module.exports = __webpack_public_path__ + "img/DE02750.3f23183a.png";